import byAttributeStart from "./references_attribute_start.svg";
import byAttributeMiddle from "./references_attribute_middle.svg";
import byAttributeFinal from "./references_attribute_final.svg";
import byGeometryStart from "./references_geometry_start.svg";
import byGeometryMiddle from "./references_geometry_middle.svg";
import byGeometryFinal from "./references_geometry_final.svg";

export const images = {
  byAttributeStart,
  byAttributeMiddle,
  byAttributeFinal,
  byGeometryStart,
  byGeometryMiddle,
  byGeometryFinal,
};
